import { redirect } from 'react-router-dom'
import {
  checkSessionProfileOnce,
  isExpiredSessionResponse,
} from '../services/session-profile-check'

export async function protectedRouteLoader() {
  try {
    await checkSessionProfileOnce()
    return null
  } catch (error: unknown) {
    if (isExpiredSessionResponse(error)) return redirect('/')
    return null
  }
}
